import { render } from "./Aside.vue?vue&type=template&id=53eece1e"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"

import exportComponent from "E:\\intellijIDEA\\Project\\yun_ji_shi_ben_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__